<template>
  <div>
    <QS-h4-title title="经营分析" />
    <QS-common-table
      :max-height="400"
      :data="tableData"
      :columns="columns"
      :pagination="false"
    />
  </div>
</template>
<script>
import { getCompanyColumns } from './config'

export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: getCompanyColumns(this),
    }
  },
}
</script>
